import script from "./HelmOpValuesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./HelmOpValuesTab.vue?vue&type=script&setup=true&lang=js"

import "./HelmOpValuesTab.vue?vue&type=style&index=0&id=448bf8e5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-448bf8e5"]])

export default __exports__